import AbstractTracker from './AbstractTracker';
import store from 'store';
import sellerStore from 'store/indexSeller';
import {isCurrentAppSeller} from 'utils/appTypeState';

class AmplitudeTracker extends AbstractTracker {

  setUser (user) {
    if (!window.amplitude) {
      return;
    }

    const amplitude = window.amplitude.getInstance();
    amplitude.setUserId(user.email);
    amplitude.setUserProperties({
      email: user.email,
      created_date: user.created_at,
      server: isCurrentAppSeller() ? sellerStore.getters['sellerCommon/appEnvName'] : store.getters['common/appEnvName']
    });
  }

  setRole (role) {
    if (!window.amplitude) {
      return;
    }
    const amplitude = window.amplitude.getInstance();
    amplitude.setUserProperties({
      role: role.name
    });
  }


  track (eventName, eventPayload = {}) {
    if (!window.amplitude) {
      return;
    }

    const amplitude = window.amplitude.getInstance();
    return new Promise(resolve => {
      amplitude.logEvent(eventName, eventPayload, () => {
        resolve();
      });
    });
  }
}

export default AmplitudeTracker;
